import request from '@/utils/request'

/**
 * @desc 代理人信息
 */
export const simple = () => {
  return request.get('/app/promoter/simple')
}

